import "./my-account-wrapper.scss";
import AccountSidebar from "../../components/account-sidebar/account-sidebar";

function MyAccountWrapper({pageName, pageDescription, children}) {

  return (
    <div className={"my-account row"}>
      <div className={"main-wrapper"}>
        <div className={"mb-3"}>
          <span className={"page-name"}>
            {pageName}
          </span>
          <span className={"mx-4"}>
            |
          </span>
          <span>
            Seja bem-vindo(a) ao seu cantinho.
          </span>
        </div>
        <div className={"row"}>
          <div className={"left-col col"}>
            <AccountSidebar/>
          </div>
          <div className={"right-col col-8"}>
            {pageDescription}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyAccountWrapper;
